import type { ResourcesStoreInterface } from "../../types/store";
import * as actionsToDispatch from "../../redux/actions";
import { useSelector } from "react-redux";
import { getStore } from "../store";

export const useResources = (resourceName: string) => {
    const store = getStore();
    const data = useSelector((state: ResourcesStoreInterface) => {
        const resources = state.resources;
        if (resources && resources[resourceName]) {
            return resources[resourceName];
        } else {
            return null;
        }
    });

    const actions = () => {
        let dispatchers = {};

        Object.keys(actionsToDispatch).forEach(function (callableName) {
            const type = actionsToDispatch[callableName]().type;
            dispatchers[callableName] = function (payload) {
                return store.dispatch({ type: type, payload: payload });
            };
        });

        let actions = { ...dispatchers };

        return actions;
    };

    return { data, actions };
};
